export const AnswerIcon = () => {
    const coachAiIcon = new URL(
        "@/coach-ai/src/assets/CoachAI_Icon.svg",
        import.meta.url
    ).href;
    return (
        <>
            <img
                src={coachAiIcon}
                alt="AI Coach Assistant"
                style={{
                    height: "60px",
                    width: "60px",
                    borderRadius: "15px",
                    marginBottom: "15px"
                }}
            />
        </>
    );
};
